/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { shareDesign } from '../../../analytics';

export default (set, get, target, currentUrl) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackShareDesign = { target, currentUrl };

  draft.digitalData.shareDesign = trackShareDesign;

  shareDesign(trackShareDesign);
}), false, { type: 'TRACK_SOCIAL_MEDIA_DESIGN_SHARE' });
